module.exports = __webpack_public_path__ + "static/media/my.c803eda4.jpeg";